import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'dynasty';
export const selectDynastyState = state => state[STORE_KEY];
export const selectDynasty = state => selectDynastyState(state).currentDynasty;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentDynasty: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_DYNASTY_REQUEST = `${STORE_KEY}/LOAD_DYNASTY_REQUEST`;
export const LOAD_DYNASTY_SUCCESS = `${STORE_KEY}/LOAD_DYNASTY_SUCCESS`;
export const LOAD_DYNASTY_ERROR = `${STORE_KEY}/LOAD_DYNASTY_ERROR`;

export const loadDynastyRequest = payload => ({
  type: LOAD_DYNASTY_REQUEST,
  payload: { ...payload },
});
export const loadDynastySuccess = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_DYNASTY_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadDynastyError = error => ({
  type: LOAD_DYNASTY_ERROR,
  payload: { error },
});

actions[LOAD_DYNASTY_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_DYNASTY_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentDynasty: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_DYNASTY_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadDynasty = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadDynastyRequest(year, week, formulaId));
    const dynasty = await api.cheatSheets.getByWeekDynasty(year);

    return dispatch(loadDynastySuccess(dynasty, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadDynastyError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const DYNASTY_VIEW = `${STORE_KEY}/DYNASTY_VIEW`;

viewNames[DYNASTY_VIEW] = 'Dynasty';
routes[DYNASTY_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/dynasty',
  thunk: async (dispatch, getState) => {
    const state = getState();

    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadDynasty(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Dynasty/module/dynasty.js